<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-Page-Break"><a id="_idTextAnchor000"></a>DEDICATORY</p>
<p class="ORIM-Chapter-Opener-Paragraph">Because he has given me permission to tell my story; because he has read that story and knows I try to speak the truth; because I believe that he is fair-minded and will cause my people to receive justice in the future; and because he is chief of a great people, I dedicate this story of my life to Theodore Roosevelt, President of the United States.</p>
<p class="ORIM-Body-Text-Right">Geronimo.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled11.vue?1a7fb795